import { logger, LOGS } from "../../utils";
import { LicenseManager } from "../license";
import { FeatureFlags } from "./FeatureFlags";
import { FeatureFlag } from "./types/user";

export class MailAnalysisFlag {
    private licenseManager: LicenseManager;

    private featureFlags: FeatureFlags;

    constructor(licenseManager: LicenseManager, featureFlags: FeatureFlags) {
        this.licenseManager = licenseManager;
        this.featureFlags = featureFlags;
    }

    public async refresh(
        readCurrentMonthEmailCount: () => number | null | undefined,
    ) {
        const flag = FeatureFlag.MAIL_ENABLE_ANALYSIS;

        // Check if userlicense is active OR Check if in grace delay
        // Check if authorizedProcessedMailPerMonth not 0
        // Check if monthly analyzed mail count < limit (read from MailManager)
        try {
            // TODO - Check grace delay
            logger.warn(
                LOGS.UserManager,
                `Grace delay not implemented yet !!!`,
            );
            const fullLicensesDetails =
                await this.licenseManager.getFullLicensesDetails();
            const hasValidLicense = this.licenseManager.hasValidLicense();
            const maxMailLimit = Math.max(
                0,
                ...fullLicensesDetails.active.map(
                    (l) => l.detail.monthlyLimit.byAnalysedMails,
                ),
            );

            const currentCount = readCurrentMonthEmailCount() ?? 0;
            const hasRemainingQuota = currentCount < maxMailLimit;

            const isEnabled = hasValidLicense && hasRemainingQuota;
            logger.info(
                LOGS.UserManager,
                `_setMailEnableAnalysis: valid=${hasValidLicense}, limit=${maxMailLimit}, count=${currentCount}, enabled=${isEnabled}`,
            );
            this.featureFlags.set(flag, isEnabled);
            return isEnabled;
        } catch (error) {
            logger.error(
                LOGS.UserManager,
                `Error checking mail analysis license: ${error}`,
            );
            this.featureFlags.set(flag, false);
            return false;
        }
    }
}
